import { Button, Divider, Stack } from "@mui/material";
import type { PropsWithChildren } from "react";
import type { Widgets } from "../../../../../api/types/dashboardsTypes";
import { useDashboardContext } from "../../contexts/DashboardContext";
import Header from "./Header";

interface Props {
  widget: Widgets;
  showApplyButton?: boolean;
  applyDisabled?: boolean;
  onApply: () => void;
}

function WidgetSettingsComponent({
  widget,
  onApply,
  children,
  showApplyButton,
  applyDisabled,
}: PropsWithChildren<Props>) {
  const { setSelectedWidgetId } = useDashboardContext();

  const handleCancelClick = () => setSelectedWidgetId(undefined);

  return (
    <Stack sx={{ width: "100%", height: "100%", flex: 1 }}>
      <Header widget={widget} />
      <Divider />
      <Stack sx={{ flex: 1, minHeight: 0, width: "100%", overflow: "auto" }}>{children}</Stack>
      <Divider />
      {showApplyButton && (
        <Stack direction="row" sx={{ gap: 1, p: 2 }}>
          <Button variant="contained" disabled={applyDisabled} onClick={onApply}>
            Apply
          </Button>
          <Button variant="text" color="secondary" onClick={handleCancelClick}>
            Cancel
          </Button>
        </Stack>
      )}
    </Stack>
  );
}

export default WidgetSettingsComponent;
